export const NEXA_FAB_CLEARANCE_SELECTOR =
  '[data-testid="pagination-footer"], [data-testid="data-table-pagination"], [data-nexa-fab-clear]';

export const NEXA_FAB_BOTTOM_ZONE_PX = 110;

export function elementIntersectsBottomZone(
  el: Element,
  viewportHeight: number,
  zonePx: number = NEXA_FAB_BOTTOM_ZONE_PX,
): boolean {
  const r = el.getBoundingClientRect();
  if (r.width <= 0 || r.height <= 0) return false;
  return r.bottom > viewportHeight - zonePx && r.top < viewportHeight;
}

export function shouldRaiseNexaFab(options: {
  isMobile: boolean;
  clearanceElements: Iterable<Element>;
  viewportHeight: number;
}): boolean {
  if (!options.isMobile) return false;
  for (const el of options.clearanceElements) {
    if (elementIntersectsBottomZone(el, options.viewportHeight)) return true;
  }
  return false;
}
